/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
// *******************************************************************************
// Sparkling Star
// *******************************************************************************

window.addEventListener('DOMContentLoaded', () => {
  const sparklingStarEle = document.querySelectorAll('.sparkling-star');
  const stars = 150;
  const sparkle = 20;

  let size = 'small';

  const createStar = (sizeClass) => {
    sparklingStarEle.forEach((el) => {
      el.innerHTML += `<div class="sparkling-star__image shine ${sizeClass}"></div>`;
    });
  };

  for (let i = 0; i < stars; i++) {
    if (i % 2 === 0) {
      size = 'small';
    } else if (i % 3 === 0) {
      size = 'medium';
    } else {
      size = 'large';
    }
    createStar(size);
  }

  const sparklingStarImageEle = document.querySelectorAll('.sparkling-star__image.shine')

  sparklingStarImageEle.forEach((el) => {
    el.style.top =  `${Math.random() * 110}%`;
    el.style.left = `${Math.random() * 110}%`;
    el.style.webkitAnimationDelay = `${Math.random() * sparkle}s`;
    el.style.mozAnimationDelay = `${Math.random() * sparkle}s`;
  });
});

